import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { LangProvider } from "../contexts/LangContext";
import { ChatPage } from "../pages/ChatPage";

export const Route = createFileRoute("/chat")({
  head: () => ({
    meta: [{ title: "Chat — Lotin.uz" }],
  }),
  component: Chat,
});

function Chat() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    if (i18n?.changeLanguage) {
      i18n.changeLanguage("default");
    }
    document.title = "Chat — Lotin.uz";
  }, [i18n]);

  return (
    <LangProvider lang="uz-Latn">
      <ChatPage />
    </LangProvider>
  );
}
